import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import {
  ErrorBlock,
  LoadingRow,
} from "../DataModelFieldSectionList/DataModelFieldSectionList.styles";

/** Figma "Modal" body (6433:560623): 12px padding, 12px between blocks. */
export const Body = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${spacing[3]};
  width: 100%;
  padding: ${spacing[3]};
  background: ${rawColors.structural.white};
  border-radius: 0 0 ${borderRadius.xl} ${borderRadius.xl};
`;

export const Description = styled.p`
  margin: 0;
  overflow-wrap: anywhere;
  ${typographyMixin("body", 4)}
  color: ${rawColors.text.highEmphasis};
`;

export const Completeness = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[1]};
  width: 100%;
`;

export const CompletenessLabel = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

/** Two columns; each tile spans 1 or 2 per the registry layout. */
export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${spacing[3]};
  width: 100%;
`;

export const StatCell = styled.div<{ $span: 1 | 2 }>`
  grid-column: span ${({ $span }) => $span};
  min-width: 0;
`;

/** The Data models list's loading/error recipes, minus their inset — the body already pads. */
export const BodyLoadingRow = styled(LoadingRow)`
  padding: 0;
`;

export const BodyErrorBlock = styled(ErrorBlock)`
  padding: 0;
`;
